// @flow

import ApiObject from '../ApiObject';

/**
 * Define the pro permissions.
 * All first sub-permissions must be declared as null here.
 */
export default class ProPermissionsList extends ApiObject {

  booking = {
    book: null,

    settings: null
  };

  proAccount = {
    self: null,

    role: null,

    domain: null,

    restaurantsGroup: null,

    restaurant: null
  };

  restaurantMenu = {
    settings: null
  };


  order = {
    settings: null
  };

  restaurantSettings = {
    publicInfo: null,

    menu: null,

    openingHours: null,

    legal: null,

    finance: null,

    features: null,

    configuration: null,

    theme: null
  };

  export = {
    canExport: null,
  }
}
